import { Form } from 'antd';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';

const listColor = [
  '#FFF',
  '#E5E6EB',
  '#C6E9EF',
  '#A8DEE8',
  '#6FABB6',
  '#2D6772',
  '#FDF4CE',
  '#FBD277',
  '#F5B945',
  '#FF8890',
  '#F76C82',
  '#D94452',
  '#FB836F',
  '#FA6C51',
  '#E8553E',
  '#66D4F1',
  '#73B0F4',
  '#4A88DA',
  '#B4DF80',
  '#9ED26A',
  '#89C053',
  '#61DDBC',
  '#46CEAC',
  '#35BA9B',
  '#DAD4FF',
  '#B3A4EE',
  '#9579DA',
  '#F199CE',
  '#EB86BE',
  '#D56FAC',
];

type IColorTableProps = {
  value?: IStaffItemData;
};

const ColorTable = ({ value }: IColorTableProps) => {
  const form = Form.useFormInstance();

  const onChangeStaffColorById = (id: string, color: string) => {
    const newStaffs = form.getFieldValue('staffs').map((staff: IStaffItemData) => {
      if (staff.id === id) {
        return { ...staff, color };
      }
      return staff;
    });
    form.setFieldValue('staffs', newStaffs);
  };

  return (
    <Wrapper>
      <div className='label'>Theme Colors</div>
      <Container>
        <div className='theme-list'>
          {listColor.map((item, index) => (
            <div
              key={index}
              className={`${String(value?.color || '').toLowerCase() === String(item).toLowerCase() ? 'theme-item-selected' : ''}`}
              onClick={() => onChangeStaffColorById?.(value?.id || '', item)}
            >
              <div className='theme-item' style={{ background: item }} />
            </div>
          ))}
        </div>
      </Container>
    </Wrapper>
  );
};

export default ColorTable;

const Wrapper = styled.div`
  width: 100%;
  padding: 24px 24px 24px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  .label {
    color: #505050;
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

const Container = styled.div`
  width: 100%;
  .theme-list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 8px;
    width: 100%;
  }
  .theme-item {
    cursor: pointer;
    border: 1px solid #adadad;
    box-sizing: border-box;
    width: 100%;
    aspect-ratio: 1/1;
    border-radius: 4px;
    background: #fff;
  }
  .theme-item-selected {
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    border: 1px solid #dc5500;
    background: #dc5500;
  }
`;
